import React, { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsLoggedIn } from '../../redux/slice/authSlice';
import { toast } from 'react-toastify';
import { SET_PREVIOUS_URL,  selectAllTasks  } from '../../redux/slice/taskSlice';
import ThreeDScene from '../../components/ThreeDScene';
import { Container, Grid, Box, Button } from '@mui/material';
import SplitText from  '../../components/splitText/SplitText';
import Carousel from '../../components/Carousel';
import TaskList from '../TaskList';
import TaskForm from '../../components/TaskForm'; 
import AIChatAssistant from '../../components/AIChatAssistant'; 
import UserBehaviorAnalysis from '../../components/UserBehaviorAnalysis';
import './Dashboard.scss';

const Dashboard = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const tasks = useSelector(selectAllTasks);
  const dispatch = useDispatch();

 // const { loading: loadingAuth } = useContext(AuthContext);

  const [openTaskForm, setOpenTaskForm] = useState(false);
  

  const handleAnimationComplete = () => { /* ... */ };

  const redirectToLogin = (intendedPath) => {
    console.log('[Dashboard] redirectToLogin called. Redirecting to /login from', intendedPath);
    toast.info("You must sign in to access this feature.", { /* ... */ });
    dispatch(SET_PREVIOUS_URL(intendedPath));
    navigate('/login');
  };

  const handleOpenTaskForm = () => { 
    console.log('[Dashboard] handleOpenTaskForm called. Redux isLoggedIn:', isLoggedIn);
    if (!isLoggedIn) {
      redirectToLogin('/tasks/new'); 
    } else {
      setOpenTaskForm(true); 
    }
  };

  const handleCloseTaskForm = () => {
    setOpenTaskForm(false);
    
  };


  const handleNavigateToTaskList = () => {
    console.log('[Dashboard] handleNavigateToTaskList called. Redux isLoggedIn:', isLoggedIn);
    if (!isLoggedIn) {
      redirectToLogin('/tasks');
    } else {
      navigate('/tasks');
    }
  };


  

  return (
    <Box className="dashboard">

      <div className="three-scene-background">
        <ThreeDScene />
      </div>

      <header className="dashboard-header">
        <SplitText
          text="Welcome to Your AI-Powered Task Manager!"
          className="text-2xl font-semibold text-center"
          delay={100}
          duration={0.6}
          ease="power3.out"
          splitType="chars"
          from={{ opacity: 0, y: 40 }}
          to={{ opacity: 1, y: 0 }}
          threshold={0.1}
          textAlign="center"
          onLetterAnimationComplete={handleAnimationComplete}
        />
        <p>Manage your tasks <span style={{ color: "#192435", fontWeight: "bold" }}>efficiently</span> with our <span style={{ color: "#192435", fontWeight: "bold", filter: "brightness(150%)" }}>advanced tools</span>.</p>
      </header>

      <Box className="dashboard-main" sx={{ position: 'relative', height: 'auto', marginBottom: '30px' }}>
        <div className="left-buttons">
          <Button variant="contained" className="button-92" onClick={handleNavigateToTaskList} sx={{ mr: 2 }}>
            View All Tasks
          </Button>
          <Button variant="contained" className="button-92" onClick={handleOpenTaskForm}>
            Create New Task
          </Button>
        </div>
      </Box>

      <Container maxWidth="lg" sx={{ paddingBottom: '30px' }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Box className="swiper-container">
              <Carousel tasks={tasks} />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <UserBehaviorAnalysis />
          </Grid>

          <Grid item xs={12}>
            <Box className="task-section">
              <TaskList /> 
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ mt: 5 }}>
        <AIChatAssistant />
      </Box>
      </Container>

     
      <TaskForm
        open={openTaskForm}
        handleClose={handleCloseTaskForm}
        taskToEdit={null} 
      />
    </Box>
  );

} 

export default Dashboard;
